export const ALL_VALUE = 'allAssets';
export const SELECT_ACTION = 'select-option';
export const DESELECT_ACTION = 'deselect-option';
